import React, { useState, useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Container } from 'reactstrap';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import { useTranslation } from 'react-i18next';
import { SpinnerLoader } from '../shared/spinnerLoader';
import { SpinnerLoaderType } from '../../Helpers/enums';

const ImageUploadModal = ({
  showModal,
  onImageSubmit,
  onToggle,
  initialFileUrl,
  setFileToUpload,
  uploadingCV,
  showReplaceDiv,
  deleteFile,
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('translations');

  const handleSubmit = (files, allFiles) => {
    setLoading(true);
    onImageSubmit(files, allFiles);
  };

  const loaderOff = useCallback(() => {
    setLoading(false);
  }, []);

  return (
    <Modal isOpen={showModal} onClosed={loaderOff} centered>
      <ModalHeader>
        <em className="fa-2x fa fa-images mr-2"> {uploadingCV ? t('common.UPLOAD_FILE') : t('common.UPLOAD_IMAGE')}</em>
      </ModalHeader>
      {loading ? (
        <Container className="container-md">
          <SpinnerLoader loaderType={SpinnerLoaderType.Small} />
        </Container>
      ) : (
        <ModalBody>
          <Container className="container-md">
            {showReplaceDiv ? (
              <div>
                <img
                  src={initialFileUrl}
                  alt="Initial"
                  className="img-fluid"
                  style={{ maxWidth: '120px', minWidth: '30px' }}
                />
                <Button className="ml-2" onClick={() => setFileToUpload(null)}>
                  {t('common.REPLACE')}
                </Button>
                <Button color="danger" className="ml-2" onClick={() => deleteFile()}>
                  {t('common.DELETE')}
                </Button>
              </div>
            ) : (
              <Dropzone
                onSubmit={handleSubmit}
                maxFiles={1}
                inputContent={uploadingCV ? t('common.DRAG_DROP_FILE') : t('common.DRAG_DROP_IMAGE')}
                accept={uploadingCV ? undefined : 'image/*'}
                inputWithFilesContent={(files) => `${1 - files.length} more`}
                submitButtonDisabled={(files) => files.length < 1}
                styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
                submitButtonContent={t('common.SUBMIT')}
              />
            )}
          </Container>
        </ModalBody>
      )}
      <ModalFooter>
        <Button color="secondary" onClick={onToggle}>
          {t('common.CANCEL')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ImageUploadModal;
